let eventMap = {};

const generateKey = (event, timeStamp) =>
	timeStamp ? `${event}-${timeStamp}` : event;

const setEventHasRun = (key, value) => {
	eventMap[key] = value;
};

const getEventHasRun = (key) => eventMap[key];

/**
 * Used to prevent events from firing twice. This issue was discovered when an event handler fired on
 * nested selectors that were both delegated to such as `button, a[href]` for the
 * ddc.generic.link event.
 *
 * @param event is the DDC DataLayer Event System Name (ie. ddc.form.submission)
 * @param timeStamp is the jquery event.timeStamp
 * @returns {boolean} true or false depending on if the event ran or not
 */
export const eventHasRun = (
	event,
	{ value = true, timeStamp = false } = {}
) => {
	const key = generateKey(event, timeStamp);

	// if event+timeStamp has never run add to map and return false
	if (!getEventHasRun(key)) {
		setEventHasRun(key, value);
		return false;
	}

	return true;
};

export const getEventHasRunValue = (key) => {
	return eventMap?.[key];
};

/**
 * Used to reset events for testing
 */
export const resetEvents = (win) => {
	if (win.test) {
		eventMap = {};
	}
};
